import * as React from 'react'
import './Partners.scss'
import { connect } from 'react-redux'
import { partnersForCurrentEventSelector, partnersForNonEventSelector } from '../../data/selectors'
import { ApplicationState } from '../../reducers'
import { DictionaryValue } from '../dictionary-value'
import { FooterVariation } from '../../features/global/footer/Footer'
import { Link } from 'react-router-dom'
import bind from 'bind-decorator'
import Partner from '../../models/partner'

type OwnProps = {
    variation: FooterVariation
}

type Props = OwnProps & {
    partners: Partner[]
    isEventRunning: boolean
}

class Partners extends React.Component<Props> {
    @bind
    renderPartner(partner: Partner) {
        const { isEventRunning } = this.props
        const { slug, logo, name, url } = partner

        const commonProps = {
            className: 'partners--partner-link',
            key: slug,
        }

        const internals = (
            <div className='partners--partner-wrapper'>
                <img
                    src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                    wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                    data-blink-src={logo}
                    alt={name}
                    className='partners--partner-logo'
                />
            </div>
        )

        return isEventRunning && slug ? (
            <Link to={partner.brandSlug ?  `/brands/${partner.brandSlug}` : `/partners/${slug}`} {...commonProps}>
                {internals}
            </Link>
        ) : (
            <a href={url} target='_blank' {...commonProps}>
                {internals}
            </a>
        )
    }

    render() {
        const { partners, variation } = this.props

        if (partners.length === 0) {
            return null
        }

        return (
            <div className={`partners partners--variation-${variation}`}>
                <DictionaryValue token='partners.title' />
                <div className='partners--logos'>
                    {partners.map(this.renderPartner)}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps): Props => {
    const isEventRunning = state.status.isEventRunning

    const partners = isEventRunning ? partnersForCurrentEventSelector(state) : partnersForNonEventSelector(state)

    return {
        isEventRunning,
        partners,
        variation: ownProps.variation,
    }
}

export default connect(
    mapStateToProps,
    null
)(Partners)
